module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_f_leucistic.e1d95c40.png";